// src/features/counterSlice.ts
import { createSlice } from '@reduxjs/toolkit';

interface GlobalState {
  shiftToDoItems: any[];
}

const initialState: GlobalState = {
  shiftToDoItems: [],
};

export const shiftToDoItems = createSlice({
  name: 'shiftToDo',
  initialState,
  reducers: {
    setShiftToDoItems: (state, action) => {
      state.shiftToDoItems = action.payload;
    },
  },
});

export const { setShiftToDoItems } = shiftToDoItems.actions;

export default shiftToDoItems.reducer;
